if (!customElements.get('svelli-category-reveal')) {
  customElements.define('svelli-category-reveal', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const canvas = this.querySelector('.svelli-reveal__canvas');
      const range = this.querySelector('.svelli-reveal__range');
      const left = this.querySelector('[data-scene="left"]');
      const right = this.querySelector('[data-scene="right"]');
      if (!canvas || !range || !left || !right) return;
      this.controller = new AbortController();
      const update = () => {
        const value = Number(range.value);
        canvas.style.setProperty('--reveal-position', `${value}%`);
        range.setAttribute('aria-valuetext', `${value}% ${range.dataset.leftLabel}, ${100 - value}% ${range.dataset.rightLabel}`);
        left.inert = value === 0;
        right.inert = value === 100;
        left.setAttribute('aria-hidden', String(value === 0));
        right.setAttribute('aria-hidden', String(value === 100));
      };
      range.addEventListener('input', update, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
